import { createContext } from 'react';

export interface BreadcrumbContextValue {
  labels: Record<string, string>;
  setLabel: (segment: string, label: string) => void;
  clearLabel: (segment: string) => void;
}

export const BreadcrumbContext = createContext<BreadcrumbContextValue | undefined>(undefined);
